import * as R from '../services/countries';
import { helpers } from '../utils';

export const ACTION_COUNTRIES_LOAD_LIST = 'countries/loadList';

export default {
  namespace: 'countries',

  state: {
    countriesList: [],
  },

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    // eslint-disable-next-line no-unused-vars
    * loadList({ payload }, { put, call, select }) {
      try {
        let countries = yield select(state => state.countries.countriesList);
        if (countries.length === 0) {
          countries = (yield call(R.countriesListRequest)).body.data;
        }

        yield put({
          type: 'updateStore',
          payload: {
            countriesList: countries,
          },
        });
      } catch (e) {
        helpers.processException(e);
      }
    },

  },
  // eslint-disable-next-line no-unused-vars
  * loadGroupList({ payload }, { put, call }) {
    try {
      const countriesGroupListResponse = yield call(R.countriesGroupListRequest);

      yield put({
        type: 'updateStore',
        payload: {
          countriesGroupList: countriesGroupListResponse.data,
        },
      });
    } catch (e) {
      helpers.processException(e);
    }
  },
};



// WEBPACK FOOTER //
// ./src/models/countries.js